'use strict';
var parent = require('../../stable/object/entries');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/object/entries.js
// module id = 332
// module chunks = 0